export default [
  {id: '1', name: '国語'},
  {id: '2', name: '数学'},
  {id: '3', name: '英語'},
  {id: '4', name: '地歴公民'},
  {id: '5', name: '理科'},
];



// WEBPACK FOOTER //
// ./src/js/constants/mockCategories.js